import { useEffect } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import DEFAULT_OPERATIONS from "./comparePage.gql";
import { useDispatch, useSelector } from "react-redux";
import { setCompareListId } from "../../features/CompareList/CompareListSlice";

export const useCreateCompareList = () => {
  const { isSignedIn } = useSelector((state) => state.loginSlice);
  const { compareListId } = useSelector((state) => state.compareListSlice);
  const { createCompareListQuery, createComparelistIdAfterSignInQuery } =
    DEFAULT_OPERATIONS;
  const dispatch = useDispatch();

  const [createCompareListId, { data }] = useMutation(createCompareListQuery, {
    onCompleted: (data) => {
      dispatch(setCompareListId(data.createCompareList.uid));
    },
    skip: isSignedIn,
  });

  const [createCompareListIdAfterSignIn, { data: CompareListdataAfterSign }] =
    useLazyQuery(createComparelistIdAfterSignInQuery, {
      onCompleted: (data) => {
        dispatch(setCompareListId(data.customer.compare_list.uid));
      },
      skip: !isSignedIn,
    });

  useEffect(() => {
    if (!compareListId && !isSignedIn) {
      createCompareListId();
    }
  }, [compareListId, isSignedIn]);

  useEffect(() => {
    if (!compareListId && isSignedIn) {
      createCompareListIdAfterSignIn();
    }
  }, [compareListId, isSignedIn]);

  const CompareId =
    data && data.createCompareList && data.createCompareList.uid
      ? data.createCompareList.uid
      : "";

  return { CompareId };
};
